"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _ActivityReportingButtonsComponent = _interopRequireDefault(require("./ActivityReportingButtonsComponent"));
var _sidePaneActions = require("../../../redux/actions/sidePaneActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapDispatchToProps = {
  openReportsSidePane: _sidePaneActions.openReportsSidePane
};
var _default = exports["default"] = (0, _reactRedux.connect)(null, mapDispatchToProps)(_ActivityReportingButtonsComponent["default"]);